import { Link } from 'react-router-dom';

interface CtaAction {
  label: string;
  to: string;
  icon: string;
}

interface CtaBannerProps {
  eyebrow?: string;
  title: string;
  description?: string;
  primary: CtaAction;
  secondary?: CtaAction;
}

export default function CtaBanner({ eyebrow, title, description, primary, secondary }: CtaBannerProps) {
  return (
    <section className="w-full bg-background-50 py-14 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-primary-900 px-6 py-10 md:px-14 md:py-14">
          <div className="pointer-events-none absolute top-0 right-0 w-72 h-72 rounded-full bg-primary-700/40 blur-3xl"></div>
          <div className="pointer-events-none absolute bottom-0 left-1/3 w-56 h-56 rounded-full bg-accent-600/20 blur-3xl"></div>

          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              {eyebrow ? (
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-accent-300">
                  <span className="w-6 h-px bg-accent-300"></span>
                  {eyebrow}
                </span>
              ) : null}
              <h2 className="font-heading mt-3 text-2xl md:text-4xl font-semibold leading-tight text-background-50">
                {title}
              </h2>
              {description ? (
                <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100/85">{description}</p>
              ) : null}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
              <Link
                to={primary.to}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${primary.icon} text-base`}></i>
                {primary.label}
              </Link>
              {secondary ? (
                <Link
                  to={secondary.to}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 bg-background-50/10 backdrop-blur-sm text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={`${secondary.icon} text-base`}></i>
                  {secondary.label}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}